import Image from "next/image"
import upscbanner1 from "../../assets/images/home/Banner/UPSC-result-web-banner-2026.jpg";
import MobBanner from "../../assets/images/home/Banner/UPSC-CSE-2025-Webbanner.jpg";
// import phone from "../../assets/images/upsc/phone.png";
import styles from "../upsc-admission-anna-nagar/upsc-ias-ips-admission.module.css";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import downloadicon from "../../assets/images/download.png";
import dynamic from "next/dynamic";
// import Upsc_popup from "../../assets/images/home/Odisha.jpg";
import Modal from 'react-bootstrap/Modal';
import Close from "../../assets/images/home/Icon ionic-ios-close-circle.png";
const Interest = dynamic(()=>import("../../components/might-be-interest"));
const Acheiver = dynamic(()=>import("../../components/our-acheiver/achievers"));
const BranchAddress = dynamic(()=>import("../../components/branch-address"));
const ObtionalButton = dynamic(()=>import("../../components/optionalbutton"));
import Program_Features from "../upsc-admission-anna-nagar/upsc-ias-ips-admission-program-features";
import Classroom_form from "../upsc-admission-anna-nagar/upsc-ias-ips-admission-form";
import sadhana from "../../assets/images/upsc/sadhanaL-2.png";
import Link from "next/link";
import Head from "next/head";
import Emioption from "../../components/Service/emioption";
import useDownloader from "react-use-downloader";
import Optionalplus from "../../components/Service/optionalplus";
import { useEffect, useState } from 'react';
import { useRouter } from "next/router";
const UPSCClassroomOnline = () => {

  const {download} = useDownloader();

  const fileUrl = "/pdf/admission/SIA-Brochure-2025-Annanagar.pdf";
  const filename = "SIA-Brochure-2025-Annanaga.pdf"

  const feestructure =[
     {date:"27.07.2026", cont:(<><div>Regular</div><div>(Hybrid)</div></>), cont1:"11.00 am to 1.30 pm"},

    // {date:"06.06.2025", cont:"Regular", cont1:"09:30 am to 12:30 pm"}
  ]

  const feestructure2 =[
     {date:"25.08.2026", cont:(<><div>Regular</div><div>(Hybrid)</div></>), cont1:"02:00 pm to 04:00 pm"},

    
  ]
   const feestructure3 =[
    
    {date:"04.07.2026",cont:"Weekend",cont1:"PSIR",cont2:"09:00 am to 01:00 pm"},
    {date:"11.07.2026",cont:"Weekend",cont1:"Geography",cont2:"09:00 am to 01:00 pm"},
    {date:"11.07.2026",cont:"Weekend",cont1:"Tamil literature",cont2:"09:00 am to 01:00 pm"},
    {date:"11.07.2026",cont:"Weekend",cont1:"Mathematics",cont2:"08:30 am to 01:30 pm"},
    {date:"12.07.2026",cont:"Weekend",cont1:"History",cont2:"09:00 am to 01:00 pm"},
    {date:"25.07.2026",cont:"Weekend",cont1:"Public Administration",cont2:"09:00 am to 01:00 pm"},
    {date:"25.07.2026",cont:"Weekend",cont1:"Psychology",cont2:"09:00 am to 01:00 pm"},
    {date:"01.08.2026",cont:"Weekend",cont1:"Economics",cont2:"09:00 am to 01:00 pm"},
    
    {date:"06.07.2026",cont:"Regular",cont1:"Anthropology",cont2:"02:30 pm to 04:30 pm"},
    {date:"20.07.2026",cont:"Regular",cont1:"Agriculture",cont2:"06:30 pm to 08:30 pm"},
    {date:"24.07.2026",cont:"Regular",cont1:"Sociology",cont2:"05:00 pm to 07:30 pm"},
    {date:"14.08.2026",cont:"Regular",cont1:"English",cont2:"02:30 pm to 05:00 pm"},
    {date:"14.09.2026",cont:"Regular",cont1:"Law",cont2:"02:30 pm to 05:00 pm"}
   
   
     
   
  ]

  const jsonLd ={
        "@context": "https://schema.org",
        "@type": "WebPage",
        "name": "IAS Coaching in Bhubaneswar | Shankar IAS Academy",
        "url": "https://www.shankariasacademy.com/bhubaneswar/",
        "Image":
        "https://www.shankariasacademy.com/_next/static/media/Pre-book-2024_Webbanner-Without-button.6686241b.webp",
        "description": "Achieve UPSC greatness with best IAS Coaching in Bhubaneswar. Comprehensive curriculum, dedicated faculty, and a history of success await you."
  }

const [modalIsOpen, setModalIsOpen] = useState(false);
const openModal = () => setModalIsOpen(true);
const closeModal = () => setModalIsOpen(false);

useEffect(() => {

  if (typeof window === "undefined") return;

  console.log("Waiting before showing popup...");

  const timer = setTimeout(() => {
    console.log("Opening popup after delay");
    openModal();
  }, 1000);

  return () => clearTimeout(timer);
}, []);

const [play, setPlay] = useState(false);
const [play1, setPlay1] = useState(false);



  const router = useRouter();
  

  useEffect(() => {
    const handleRouteChange = (url) => {
      console.log(`Navigated to ${url}`);
      router.reload(); // Refresh the page on route change
    };

    router.events.on("routeChangeComplete", handleRouteChange);

    // Cleanup on component unmount
    return () => {
      router.events.off("routeChangeComplete", handleRouteChange);
    };
  }, [router]);

  const getBranchName = () => {
  switch (router.pathname) {
    case "/adyar":
      return "Adyar";
    case "/trichy":
      return "Trichy";
    case "/salem":
      return "Salem";
    case "/madurai":
      return "Madurai";
    case "/coimbatore":
      return "Coimbatore";
    case "/upsc-admission-anna-nagar":
      return "Tamil Nadu";
    default:
      return "Tamil Nadu";
  }
};

   const branches = [
    
    { name: "Bengaluru", path: "/bengaluru" },
    { name: "Delhi", path: "/delhi" },
    { name: "Hyderabad", path: "/hyderabad" },
    { name: "Bhubaneswar", path: "/bhubaneswar" },
    { name: "Thiruvananthapuram", path: "/thiruvananthapuram" },
    { name: "Online Class", path: "/upsc-online-class" },
    { name: "NRI", path: "/upsc-admission-nri" },

  ];

  return (
    <>
     <Head>
     
        <script async src="https://www.googletagmanager.com/gtag/js?id=G-KK7QL7XRX3"></script>
        <script>
          {
          `
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', 'G-KK7QL7XRX3');
          `
          }
        </script>

                <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd,null, "\t") .replaceAll("],\n\t\"", "],\n\n\t\"") }} />
                <meta charset="UTF-8" />               
                <meta name="viewport" content="width=device-width, initial-scale=1" />
                <meta name="robots" content="noodp,noydir" />
                <meta name="robots" content="index,follow" />
                <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
                <meta property="article:publisher" content="https://www.facebook.com/shankariasacademy" />
                <meta property="article:modified_time" content="2024-01-25T05:43:44+00:00" />
                <title>IAS Coaching in Bhubaneswar | Shankar IAS Academy</title>
                <meta name="title" content="IAS Coaching in Bhubaneswar | Shankar IAS Academy" />
                <meta name="description" content="Achieve UPSC greatness with best IAS Coaching in Bhubaneswar. Comprehensive curriculum, dedicated faculty, and a history of success await you." />
                <link rel="canonical" href="https://www.shankariasacademy.com/bhubaneswar/" />
                <meta property="og:locale" content="en_US" />
                <meta property="og:type" content="website" />
                <meta property="og:title" content="IAS Coaching in Bhubaneswar | Shankar IAS Academy" />
                <meta property="og:description" content="Achieve UPSC greatness with best IAS Coaching in Bhubaneswar. Comprehensive curriculum, dedicated faculty, and a history of success await you." />
                <meta property="og:url" content="https://www.shankariasacademy.com/bhubaneswar/" />
                <meta property="og:site_name" content="Shankar IAS Academy" />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:site" content="@shankarias" />
                <script>{`var s=document.createElement("script"); s.type="text/javascript"; s.async=true; s.src="https://widgets.in6.nopaperforms.com/emwgts.js"; document.body.appendChild(s); `}</script>
              </Head>

      {/* <Modal
        size="md"
        centered
        show={modalIsOpen}
        onHide={closeModal}
        aria-label="UPSC Modal"
        className="blur"
      >
        <Modal.Body className="p-0">
          <div className="position-absolute  p-0 p-md-1 closebtn">
           <Image loading="eager" placeholder="blur" onClick={closeModal} alt="Close icon" title="Close modal" src={Close} className="img-fluid" style={{ cursor: "pointer", width: "20px" }} />   
          </div>
          < Link
              href="#gspcm"
              className={`${styles.acheiverrank, styles.courseshover2}`}
              id="" 
              target="_blank" 
           >
            <Image src={Upsc_popup} alt="Modal Banner" className="img-fluid w-100"  useMap="#image-map"/>
             <p class="p-2">"Telegram channel is not available at the moment. Please refer to the Shankar IAS Academy Testpress portal for the latest updates and information." </p>
          </Link> 
        </Modal.Body>
      </Modal>  */}

      <Navbar title="upsc" />

      <div className="container">
          <div className="row justify-content-center">
            <div className="col-12 pt-3 pt-md-4">

              {/* Desktop View */}
              <div className={`${styles.tabscrollclass} ${styles.desktopView}`}>

                <div className={styles.dropdown}>
                  <span className={styles.tamilNaduBtn}>
                    {getBranchName()}
                  </span>
                  <ul className={styles.dropdownmenu}>
                    <li><Link href="/upsc-admission-anna-nagar" className={styles.dropdownitem}>Anna Nagar</Link></li>
                    <li><Link href="/adyar" className={styles.dropdownitem}>Adyar</Link></li>
                    <li><Link href="/coimbatore" className={styles.dropdownitem}>Coimbatore</Link></li>
                    <li><Link href="/trichy" className={styles.dropdownitem}>Trichy</Link></li>
                    <li><Link href="/salem" className={styles.dropdownitem}>Salem</Link></li>
                    <li><Link href="/madurai" className={styles.dropdownitem}>Madurai</Link></li>
                  </ul>
                </div>

                {branches.map((branch) => (
                  <Link key={branch.path} href={branch.path}>
                    <button
                      className={
                        router.pathname === branch.path
                          ? styles.activeBranch
                          : styles.normalBranch
                      }
                    >
                      {branch.name}
                    </button>
                  </Link>
                ))}
              </div>

              {/* Mobile & Tablet View */}
              <div className={styles.mobileView}>

                <div className={styles.dropdown}>
                  <span className={styles.tamilNaduBtn}>
                    {getBranchName()}
                  </span>

                  <ul className={styles.dropdownmenu}>
                    <li><Link href="/upsc-admission-anna-nagar" className={styles.dropdownitem}>Anna Nagar</Link></li>
                    <li><Link href="/adyar" className={styles.dropdownitem}>Adyar</Link></li>
                    <li><Link href="/coimbatore" className={styles.dropdownitem}>Coimbatore</Link></li>
                    <li><Link href="/trichy" className={styles.dropdownitem}>Trichy</Link></li>
                    <li><Link href="/salem" className={styles.dropdownitem}>Salem</Link></li>
                    <li><Link href="/madurai" className={styles.dropdownitem}>Madurai</Link></li>
                  </ul>
                </div>

                {branches.map((branch) => (
                  <Link key={branch.path} href={branch.path}>
                    <button
                      className={
                        router.pathname === branch.path
                          ? styles.activeBranch
                          : styles.normalBranch
                      }
                    >
                      {branch.name}
                    </button>
                  </Link>
                ))}
              </div>
            </div>
          </div>
      </div>
                
      <div className="container pt-2">
        <div className="row">
          <div className="col pt-3 pt-md-4">
            <h1 className={`${styles.pagemaintitle}`}>UPSC - Classroom & Online - Bhubaneswar</h1>            
          </div>

          <div className="row d-none d-md-block">
            <div className="col pt-3 ">
              <Image src={upscbanner1} alt="UPSC Coaching in Bhubaneswar" title="UPSC - Classroom & Online - Bhubaneswar" className="img-fluid w-100"/>
            </div>
          </div>

          <div className="row d-block d-md-none">
            <div className="col pt-3 pt-md-5">
              <Image src={MobBanner} alt="UPSC Coaching in Bhubaneswar" title="UPSC - Classroom & Online - Bhubaneswar" className="img-fluid w-100"/>
            </div>
          </div>
        </div>
      </div>

      <div className="container pb-5">
        <div className={`${styles.coursesimg} mb-2`}>
          <div class="col-12 col-md-6 offset-md-3 mt-4">
            <p className={`${styles.contactheader} text-center`}>Enquiry</p>
            <p className={`${styles.acheiverrank} text-center mb-0 `}>kindly fill out the form below. We will get in touch with you shortly.</p>
            <div class={`${styles.addmissionform} npf_wgts mt-2`} data-height="550px" data-w="3f4274baec4df825dd72c5ff92d085ff"> </div> 
          </div>
        </div>
      </div>

      {/* <div className="container-fluid">
        <div className={`${styles.bestbg1}`}>
          <div className="row g-4 mt-2">
            <div className="col-12 col-md-6 col-lg-12">
              <div className="card shadow-sm p-4">
                <h2> <span style={{fontSize:"20px",color:'#db1b0d' ,fontWeight:"bold"}}>Pre Booking Open</span></h2> 
                  <p>For pre-booking, contact the number - <span style={{color:'#db1b0d' }}>93902 42708</span></p>
                  <div className={`${styles.brochure} justify-content-center`}>
                    <a href="https://www.shankariasacademy.com/pdf/UPSC-2026/Brochure-bhubaneswar-Admission-2026.pdf" target="_blank" rel="noopener noreferrer">
                      <button className={`${styles.normalbutton1} btn btn-danger`}>
                        <Image src={downloadicon} alt="download icon" /> UPSC GSPCM 2026 (Brochure)
                      </button>
                    </a>
                </div>
              </div>
            </div>   
          </div>
        </div>
      </div> */}

       <div className="container">
        <div className="row pt-2">
          <div className="col-xl-6  col-lg-6 mb-3 mb-md-4 col-12">
              <h2 className={`${styles.sectiontitle} pt-3`}>Course and Fees</h2>
          </div>

          <div className="col-xl-4 offset-xl-2 col-lg-6 mb-3 mb-md-4 col-12">
             <div className={`${styles.brochure} `}>
                    <a href="https://www.shankariasacademy.com/pdf/UPSC-2026/Brochure-bhubaneswar-Admission-2026.pdf" target="_blank" rel="noopener noreferrer">
                      <button className={`${styles.normalbutton1} btn btn-danger`}>
                        <Image src={downloadicon} alt="download icon" /> UPSC GSPCM 2026 (Brochure)
                      </button>
                    </a>
                </div>
          </div>
        </div>
        </div>

      <div className="container" id="gspcm">
        <div className="row pt-2">
    
            <div className="col-xl-4 col-lg-6 mb-3 mb-md-4 col-12">
              <div className="row p-2">
                <div className={`${styles.facultyborder3} col-lg-8`} >
                  <p className={`${styles.sectionsubtitle} mb-0 mx-3`}>General Studies</p>
                  <p className={`${styles.sectionsubtitle} mx-3`}>(Preliminary Cum Mains)</p>
                  <span className={`${styles.acheiverrank} mx-3`}> <span className={`${styles.sectionredtitle} pe-1`}><b>₹</b>1,02,000</span><span style={{verticalAlign: "top"}}>(inclusive of tax)</span></span>
                </div>

                <div className={`${styles.facultyborder3} col-lg-4 pt-4`} >
                  <a href="https://admissionsv1.shankariasacademy.com/?center=BHUBANESWAR&coursetype=UPSC" target="_blank" rel="noreferrer" className={`${styles.viewbuttonalink}`}><button type="button" className={`${styles.gsbutton}`}>Pay Here</button></a>
                </div>
              </div>
              
            <div className="pt-3">       
              <div className="row mx-auto">
                <div className="col ps-0">
                <table className="table ">
                  <tbody>
                  {feestructure.map((item,index)=>(
                    <tr key={index}>
                      <td className={`${styles.classacheiverrank} mb-0`}>{item.date}</td>
                      <td className={`${styles.classacheiverrank} mb-0`}>{item.cont}</td>
                      <td className={`${styles.classacheiverrank} mb-0`}>{item.cont1}</td>
                    </tr>
                    ))}
                    <tr>
                  
                    </tr>
                  </tbody>
                </table>
                </div>
              </div>
            </div>
            </div>

            <div className="col-xl-4 col-lg-6 mb-3 mb-md-4 col-12">
              <div className="row p-2">
                <div className={`${styles.facultyborder3} col-lg-8`} >
                  <p className={`${styles.sectionsubtitle} mb-0 mx-3`}>CSAT</p>
                  <span className={`${styles.acheiverrank} mx-3`}> <span className={`${styles.sectionredtitle} pe-1`}><b>₹</b>14,000</span><span style={{verticalAlign: "top"}}>(inclusive of tax)</span></span>
                </div>

                <div className={`${styles.facultyborder3} col-lg-4 pt-4`} >
                  <a href="https://admissionsv1.shankariasacademy.com/?center=BHUBANESWAR&coursetype=UPSC" target="_blank" rel="noreferrer" className={`${styles.viewbuttonalink}`}><button type="button" className={`${styles.gsbutton}`}>Pay Here</button></a>
                </div>
              </div>
                

              <div className="pt-3">       
                <div className="row mx-auto">
                  <div className="col ps-0">
                  <table className="table ">
                    <tbody>
                    {feestructure2.map((item,index)=>(
                      <tr key={index}>
                        <td className={`${styles.classacheiverrank} mb-0`}>{item.date}</td>
                        <td className={`${styles.classacheiverrank} mb-0`}>{item.cont}</td>
                        <td className={`${styles.classacheiverrank} mb-0`}>{item.cont1}</td>
                      </tr>
                      ))}
                    </tbody>
                  </table>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-xl-4 col-lg-6 mb-3 mb-md-4 col-12">
                <div className="row p-2">
                <div className={`${styles.facultyborder3} col-lg-8`} >
                  <p className={`${styles.sectionsubtitle} mb-0 mx-3`}>Optional</p>
                  <span className={`${styles.acheiverrank} mx-3`}> <span className={`${styles.sectionredtitle} pe-1`}><b>₹</b>34,000</span></span>
                </div>

                <div className={`${styles.facultyborder3} col-lg-4 pt-4`} >
                  <a href="https://admissionsv1.shankariasacademy.com/?center=BHUBANESWAR&coursetype=UPSC" target="_blank" rel="noreferrer" className={`${styles.viewbuttonalink}`}><button type="button" className={`${styles.gsbutton}`}>Pay Here</button></a>
                </div>
              </div>


              <div className="pt-3" id="paymentsection">       
              <div className="row mx-auto">
                <div className="col ps-0 ps-xl-0 p-xl-0">
                  <div className="table-responsive text-nowrap">
                <table className="table ">
                  <tbody>
                  {feestructure3.map((item,index)=>(
                    <tr key={index}>
                      <td className={`${styles.classacheiverrank} mb-0`}>{item.date}</td>
                      <td className={`${styles.classacheiverrank} mb-0`}>{item.cont}</td>
                      <td className={`${styles.classacheiverrank} mb-0`}>{item.cont1}</td>
                      <td className={`${styles.classacheiverrank} mb-0`}>{item.cont2}</td>
                    </tr>
                    ))}
                    {/* <tr>
                    <td colSpan="4" className={`${styles.classacheiverrank} mb-0`}><b>Forestry and Geology - After Prelims Result</b></td>
                    </tr> */}
                    <tr>
                  
                    </tr>
                  </tbody>
                </table>
                </div>
                </div>   
              </div>
            </div>
            </div>

            <div className="col-xl-3 offset-xl-8 col-lg-4 col-md-6 col-8  text-end pb-2 ">
                <ObtionalButton />
            </div>

            <div className={`${styles.facultyborder3} row p-4 h-100 mb-md-3`}>

              <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                  <p className={`${styles.sectionsubtitle} mb-0`}>GSPCM+CSAT+Optional</p>
                  <p className={`${styles.sectionsubtitle} `}>Total Amount </p>
              </div>

              <div className="col-xl-3 col-lg-4 col-md-6 col-12 py-2">
                <span className={`${styles.acheiverrank}`}> <span className={`${styles.sectionredtitle}`}><b>₹</b>1,50,000*</span><span>(inclusive of tax)</span></span> 
              </div>

              <div className="col-xl-3 col-lg-4 col-md-6 col-12 p-2  text-right">
                <Emioption />  
              </div>   

              <div className="col-xl-3 col-lg-4 col-md-6 col-12  text-right pt-xl-0 pt-3">
                <a href="https://admissionsv1.shankariasacademy.com/?center=BHUBANESWAR&coursetype=UPSC" target="_blank" rel="noreferrer" className={`${styles.viewbuttonalink}`}><button type="button" className={`${styles.normalbutton}`}>Pay Here</button></a>
              </div>
            </div>

           <div className={`${styles.facultyborder3} p-4 mb-3`}>
              <div className="row align-items-center">

                {/* Course Details */}
                <div className="col-lg-4">
                  <h5 className={`${styles.sectionsubtitle} mb-1`}>
                   <b> Moksha Mains Test Series</b>
                  </h5>

                  <p className="mb-2" style={{ fontSize: "14px", color: "#756e6e" }}>
                    Odisha Public Service Commission (OPSC)<br />
                    Civil Services Examination
                  </p>

                  <p className="mb-0">
                    <strong>Starts On:</strong> 09 August 2026
                  </p>
                </div>

                {/* Fee Structure */}
                <div className="col-lg-5 mt-4 mt-lg-0">
                  <div className="border rounded-3 p-3 bg-light">

                    <div className="d-flex justify-content-between mb-2">
                      <span>GS Test Series</span>
                      <strong>₹7,500</strong>
                    </div>

                    <div className="d-flex justify-content-between mb-2">
                      <span>Optional Test Series</span>
                      <strong>₹2,500</strong>
                    </div>

                    <hr className="my-2" />

                    <div className="d-flex justify-content-between">
                      <span className="fw-bold">Total Fee</span>
                      <span className={`${styles.sectionredtitle} fw-bold`}>
                        ₹10,000
                      </span>
                    </div>

                  </div>
                </div>

                {/* Single Pay Button */}
                <div className="col-lg-3 text-lg-end text-center mt-4 mt-lg-0">
                  <a
                     href="https://admissionsv1.shankariasacademy.com/?center=BHUBANESWAR&coursetype=OPSC"
                    target="_blank"
                    rel="noreferrer"
                    className={styles.viewbuttonalink}
                  >
                    <button type="button" className={styles.normalbutton}>
                      Pay Now
                    </button>
                  </a>
                </div>

              </div>
            </div>

            <div className={`${styles.sadhana}`}>
              <div className="container">
                  <div className="row">
                      {/* <div className="col-12 col-md-4 text-white mt-2 p-2">
                        UPSC GS-Mains Test Series 2025 (Moksha)<br />
                        <a href="/upsc-mains-test-series/" className={`${styles.normalbutton} pt-2 pe-3 pb-2 ps-3 mt-2 d-inline-block`}> Click here <span></span></a>
                        </div> */}

                      <div className="col-12 offset-md-4 col-md-4 p-2">
                          <Link href="/two-year-upsc-program">
                            <Image alt="sadhana" className="img-fluid" src={sadhana} />
                          </Link>
                      </div>

                      {/* <div className="col-12 col-md-4 text-white mt-2 p-2 order-first order-md-last">UPSC GSPCM 2025 (Brochure)<br />
                        <button className={`${styles.normalbutton2} ${styles.brochurebtn} pt-2 pe-3 pb-2 ps-3 mt-2 d-inline-block`} onClick={() => download(fileUrl, filename)}>
                            <p className=""> <Image src={downloadicon} alt="download icon" /> Download Brochure</p>
                          </button>
                      </div> */}
                  </div>
                </div>
            </div>

            <Program_Features />

            {/* Our Acheivers */}
            <div className="container">
              <div className="row">
                <div className="col pt-4 pt-md-5 text-center">
                  <h2 className={`${styles.sectiontitle} mb-0`}>Our Achievers</h2>
                  <p className={`${styles.sectionsubtitle}`}>
                    Rank Holders from our academy
                  </p>
                </div>
              </div>
            </div>

            <Acheiver />
            
            <section id="toppers">
              <div className="container">
                <div className="row">
                  <div className="  col-xl-12 col-lg-6 mb-3 mb-md-4 col-12 ">
                  <Optionalplus /> 
                  </div>
                </div>
              </div>
          </section>
        </div>
      </div> 

      <div className={styles.aboutSection}>
        <div className="container">
           <span className={styles.badge}>
            Best UPSC Coaching in Bhubaneswar
          </span>
          <h1 className={styles.heroTitle}>
            Shape Your IAS Dream with
            <span> Shankar IAS Academy</span>
          </h1>
          <div className={styles.glassCard}>
            <div className="row align-items-center g-4">

              <div className="col-xl-6 col-12">
                <p className={`${styles.hyderabadcon}`}>Are you aspiring to join the prestigious <span  className={`${styles.program1}`}> Indian Administrative Services (IAS)</span>  and looking for the best coaching institute in Bhubaneswar to guide you through your journey? Your search ends here! Welcome to our top-notch <span><Link className={`${styles.program1}`} href="/"> Shankar IAS Academy </Link></span>  Coaching Centre, where we offer unrivaled guidance and support tailored specifically for aspirants like you.</p>
                <p className={`${styles.hyderabadcon}`}>Our institute stands out as a beacon of excellence in <b>Best IAS Coaching in Bhubaneswar</b>, committed to empowering you to conquer the UPSC exam with confidence and success.</p>
               </div>

               <div className="col-xl-6 col-12">
                <div className={styles.imageCard}>
                  <Image src="/images/Bhubaneswar.jpg" alt=" IAS Coaching in Bhubaneswar" class="img-fluid" width={1067} height={654} />
                </div>
              </div>

              <div className="col-xl-12 col-12">
                <h2 className={`${styles.hyderabadtitle} mb-2`}>About Us: Your Premier IAS Academy</h2>
                <p className={`${styles.hyderabadcon} mb-0`}>Established with the vision of nurturing future civil servants, our <span><Link className={`${styles.program1}`} href="/"> IAS Academy in Bhubaneswar </Link></span>  is renowned for its excellence in coaching and comprehensive study materials. The academy has evolved over the years to the extent of successfully helping over 2200+ candidates realize their dream of becoming bureaucrats and successfully guiding thousands of others to realize their potential. We take pride in having successfully contributed to nation building in a small way.</p>
                <p className={`${styles.hyderabadcon} pt-3`}>Our faculty comprises seasoned educators and experienced trainers who are committed to providing unparalleled guidance and support to every aspirant. With their vast experience and expertise, they ensure that you receive the highest quality instruction and mentorship tailored to your individual needs.</p>
                <p className={`${styles.hyderabadcon} pt-3`}> We understand that the journey to becoming an IAS officer is challenging, which is why we prioritize creating a supportive and nurturing learning environment by regularly conducting student-achiever interactions. Whether you're a beginner taking your first steps towards your goal or a seasoned aspirant seeking to refine your skills, our academy is here to guide you at every stage of your preparation. </p>
              </div>

             
            </div>
          </div>

          
          <div className={`${styles.glassCard} mt-4`}>
              <div className="row">
                <div className="col-12">

                <h2 className={`${styles.hyderabadtitle} mb-2`}>Our Offerings: Unmatched IAS Coaching Centre in Bhubaneswar</h2>
                <h3 className={`${styles.hyderabadtitle1} mb-2`}>Comprehensive UPSC Curriculum</h3>
                <p className={`${styles.hyderabadcon}`}>Our coaching center offers a meticulously designed curriculum that covers all subjects and topics prescribed by the UPSC. From General Studies to Optional subjects, we ensure comprehensive coverage to equip you with the knowledge and skills required to excel in the exam.</p>
                <h3 className={`${styles.hyderabadtitle1} mb-2`}>Expert Faculty</h3>
                <p className={`${styles.hyderabadcon}`}>Our faculty members are seasoned experts in their respective fields, including retired civil servants, subject matter experts, and experienced educators. They bring a wealth of knowledge and experience to the classroom, providing insightful guidance and mentoring to every student.</p>

                <h3 className={`${styles.hyderabadtitle1} mb-2`}>Personalized Attention</h3>
                <p className={`${styles.hyderabadcon}`}>We understand that every aspirant has unique strengths and weaknesses. That's why we provide personalized attention to each student, offering individualized coaching, doubt-clearing sessions, and mentorship to address specific needs and challenges.</p>
                
                <h3 className={`${styles.hyderabadtitle1} mb-2`}>Strategic Approach</h3>
                <p className={`${styles.hyderabadcon} mb-2`}>Cracking the UPSC exam requires more than just academic knowledge; it requires a strategic approach. Our coaching methodology focuses on developing critical thinking, analytical skills, and effective exam strategies to maximize your chances of success.</p>
                
                <h3 className={`${styles.hyderabadtitle1} mb-2`}>Regular Mock Tests and Feedback</h3>
                <p className={`${styles.hyderabadcon} mb-2`}>To assess your progress and readiness for the exam, we conduct regular mock tests that simulate the UPSC exam environment. These tests help identify areas of improvement and provide valuable feedback to enhance your performance.</p>

                <h2 className={`${styles.hyderabadtitle} mb-2`}>Admission Process: Join the Best UPSC Coaching in Bhubaneswar</h2>
                <p className={`${styles.hyderabadcon} pt-2`}>Enrolling in our IAS Coaching Centre is easy! Simply follow these steps to kickstart your journey towards becoming an IAS officer:</p>
                
                <h3 className={`${styles.hyderabadtitle1} mb-2`}>Contact Us</h3>
                <p className={`${styles.hyderabadcon}`}> <span><Link className={`${styles.program1}`} href="https://www.shankariasacademy.com/contact-us/"> Get in touch </Link></span> with our admission team either through phone, email, or by visiting our Academy in person.</p>

                <h3 className={`${styles.hyderabadtitle1}`}>Consultation</h3>
                <p className={`${styles.hyderabadcon}`}> <span><Link className={`${styles.program1}`} href="https://www.shankariasacademy.com/admission-consultation/"> Schedule a consultation </Link></span> with our academic counselors to discuss your goals, aspirations, and the best course of action for your UPSC preparation.</p>
                
                <h3 className={`${styles.hyderabadtitle1}`}>Registration</h3>
                <p className={`${styles.hyderabadcon}`}>Complete the registration process by filling out the necessary forms and submitting the required documents.</p>
                
                <h3 className={`${styles.hyderabadtitle1}`}>Orientation</h3>
                <p className={`${styles.hyderabadcon}`}>Attend an orientation session where you'll get acquainted with our coaching methodology, faculty members, study materials, and other resources available at our institute.</p>
                
                <h3 className={`${styles.hyderabadtitle1}`}> Start Learning </h3>
                <p className={`${styles.hyderabadcon}`}>Once enrolled, dive into our comprehensive study materials, attend interactive classes, and participate in mock tests to kickstart your UPSC preparation journey.</p>
                
                <h2 className={`${styles.hyderabadtitle}`}> Join Us Today and Fulfill Your Dreams! </h2>
                <p className={`${styles.hyderabadcon}`}> Don't let the opportunity to join the best <span><Link className={`${styles.program1}`} href="/">  IAS Coaching in Bhubaneswar </Link></span> slip away! With our expert guidance, personalized attention, and proven track record of success, you'll be well-equipped to ace the UPSC exam and embark on a fulfilling career in public service. </p>
                <p className={`${styles.hyderabadcon}`}> <span><Link className={`${styles.program1}`} href="https://admissionsv1.shankariasacademy.com/Prebooking-Forms/Step1/step1?center=DELHI&&course=UPSC"> Enroll now </Link></span>  and take the first step towards realizing your aspirations of serving the nation as an IAS officer. </p>

                </div>
              </div>
          </div>

        </div>
      </div>

  
      <BranchAddress branch="bhubaneswar" />
      <Interest />
      <Footer />
    </>
  )
}

export default UPSCClassroomOnline;
